(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.EditCompaniesController = (function(superClass) {
    extend(EditCompaniesController, superClass);

    function EditCompaniesController(scope, transitions, modalInstance, service, associations) {
      var company, i, len, ref;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.save = bind(this.save, this);
      EditCompaniesController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      if (associations.data.status.type === 'success') {
        this.scope.companies = associations.data.data.companies;
        this.scope.user_companies = associations.data.data.user_companies;
      }
      ref = this.scope.companies;
      for (i = 0, len = ref.length; i < len; i++) {
        company = ref[i];
        if (this.scope.user.id === company.corporate_users_id) {
          this.scope.is_corporate_account_msg = "This user is the corporate account for " + company.name + ". You are not permitted to edit this users company associations";
          break;
        }
      }
    }

    EditCompaniesController.prototype.save = function() {
      return this.service.updateUserCompanies(this.scope.user.id, this.scope.user_companies).then((function(_this) {
        return function() {
          return _this.modalInstance.close();
        };
      })(this));
    };

    return EditCompaniesController;

  })(DialogController);

}).call(this);
